var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-navigation"},[_c('div',{staticClass:"tab-navigation__wrapper"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"tab-navigation__item",class:_vm.active === item.id && 'active',on:{"click":() => _vm.$emit('change', item.id)}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }